import React from "react";
import { useFormContext, useWatch } from "react-hook-form";

import { EMPTY_STRING } from "../../../../constants";
import { AddImage, AddImages, CrossIconWhite } from "../../../../assets";

const PropertyImages = ({
  setCoverImageIndex,
  coverImageIndex,
  setDeletedImages,
  setCoverImageId,
}) => {
  const {
    control,
    setValue,
    formState: { errors },
    trigger,
  } = useFormContext();

  const images = useWatch({ control, name: "images" });

  const handleFileChange = (e) => {
    const previousImages = images || [];
    const newImages = [...previousImages, ...e.target.files];
    setValue("images", newImages);
    trigger("images");
    e.target.value = null;
  };

  const handleRemoveFile = (index, image) => {
    const files = images;
    files.splice(index, 1);
    setValue("images", files);
    if (image.url) {
      setDeletedImages((prev) => [...prev, image.id]);
    }
    if (index < coverImageIndex) {
      setCoverImageIndex((prev) => prev - 1);
    }
  };

  return (
    <div className="create-form-card">
      <div className="form-card-heading">
        <img src={AddImages} alt={EMPTY_STRING} />
        Upload Images of Property:
      </div>
      <div
        className={`images-container ${
          errors.images ? "border-danger" : EMPTY_STRING
        }`}
      >
        {(images || []).map((image, index) => (
          <div
            className="img-container"
            onClick={() => {
              setCoverImageIndex(index);
              if (image.id) {
                setCoverImageId(image.id);
              } else {
                setCoverImageId(null);
              }
            }}
          >
            <img
              src={image.url ? image.url : URL.createObjectURL(image)}
              alt={EMPTY_STRING}
            />
            {index !== coverImageIndex && (
              <img
                src={CrossIconWhite}
                className="cross-icon"
                onClick={(e) => {
                  e.stopPropagation();
                  handleRemoveFile(index, image);
                }}
                alt={EMPTY_STRING}
              />
            )}
            {index === coverImageIndex && (
              <div className="cover-banner">Cover Image</div>
            )}
          </div>
        ))}
        <label>
          <div className="add-image">
            <input
              type="file"
              className="d-none"
              onChange={handleFileChange}
              accept=".jpg, .jpeg, .png"
              multiple
            />
            <img src={AddImage} className="pointer" alt={EMPTY_STRING} />
          </div>
        </label>
      </div>
      {errors.images && (
        <div className="error mt-2 w-100">{errors.images.message}</div>
      )}
      <div className="images-instructions">
        <div>Maximum 10 images are allowed.</div>
        <div>
          The recommended format for these images typically includes JPEG (JPG)
          or PNG file formats, a resolution of at least 1920 x 1080 pixels with
          higher resolutions preferred for better clarity and detail, an aspect
          ratio of 4:3 or 16:9 depending on the layout of the listing page, and
          a file size typically between 1MB to 5MB to balance quality and
          loading times. Images should be high-quality, professionally taken
          photos, ideally edited to enhance lighting and color balance. Both
          landscape and portrait orientations are necessary, with a preference
          for landscape for wide shots. The images should have a DPI of 72 for
          web use, although higher DPI images can be used if they need to be
          printed or zoomed in on, and should be in RGB color mode for web
          compatibility.
        </div>
      </div>
    </div>
  );
};

export default PropertyImages;
